import styled from 'styled-components'

const MAX_EVENT_DESCRIPTION_ROWS = 6

export const CalendarEventDescriptionUi = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: ${MAX_EVENT_DESCRIPTION_ROWS};
  -webkit-box-orient: vertical;
  overflow: hidden;
`
